const AES_ALGORITHM = 'AES-GCM'

type EncryptedNotePayload = {
    v: 1
    iv: string
    ciphertext: string
}

const bytesToBase64 = (bytes: Uint8Array) => btoa(String.fromCharCode(...bytes))

const base64ToBytes = (value: string) => Uint8Array.from(atob(value), (char) => char.charCodeAt(0))

export const importEncryptionKey = async (base64Key: string) => {
    return crypto.subtle.importKey('raw', base64ToBytes(base64Key), AES_ALGORITHM, false, ['encrypt', 'decrypt'])
}

export const encryptNoteContent = async (plaintext: string, key: CryptoKey) => {
    const iv = crypto.getRandomValues(new Uint8Array(12))
    const encoded = new TextEncoder().encode(plaintext)
    const ciphertext = await crypto.subtle.encrypt({ name: AES_ALGORITHM, iv }, key, encoded)

    const payload: EncryptedNotePayload = {
        v: 1,
        iv: bytesToBase64(iv),
        ciphertext: bytesToBase64(new Uint8Array(ciphertext)),
    }

    return JSON.stringify(payload)
}

export const decryptNoteContent = async (encryptedContent: string, key: CryptoKey) => {
    const payload = JSON.parse(encryptedContent) as EncryptedNotePayload
    const iv = base64ToBytes(payload.iv)
    const ciphertext = base64ToBytes(payload.ciphertext)
    const decrypted = await crypto.subtle.decrypt({ name: AES_ALGORITHM, iv }, key, ciphertext)

    return new TextDecoder().decode(decrypted)
}
